/** Filter cached picker entries locally, then group the matches by domain/group. */
export function filterAndGroupPickerItems(items, query = '') {
  const term = String(query).trim().toLocaleLowerCase();
  const groups = new Map();

  for (const item of items ?? []) {
    if (!item || typeof item.value !== 'string' || !item.value) continue;
    const domain = typeof item.domain === 'string' && item.domain
      ? item.domain
      : item.value.split('.', 1)[0];
    const service = typeof item.service === 'string' && item.service
      ? item.service
      : item.value.slice(domain.length + 1);
    const searchable = [item.value, domain, service, item.name, item.description, item.label]
      .filter(value => typeof value === 'string')
      .join('\n')
      .toLocaleLowerCase();
    if (term && !searchable.includes(term)) continue;

    if (!groups.has(domain)) groups.set(domain, []);
    groups.get(domain).push(item);
  }

  return [...groups.entries()]
    .sort(([left], [right]) => left.localeCompare(right))
    .map(([domain, groupedItems]) => ({
      domain: domain.toLocaleUpperCase(),
      items: groupedItems.sort((left, right) => left.value.localeCompare(right.value)),
    }));
}

/** Emit a selected identifier and close the picker in a consistent order. */
export function selectPickerItem(value, emit) {
  emit('select', value);
  emit('update:show', false);
}
